import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import DailySaleFollowupHistory from './DailySaleFollowupHistory'
import MasterFollowUps from './MasterFollowUps'

function MasterFollowUpsContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "Master",
    navSubTitle: "Welcome to ImagesBazaar"
  })
  const handleNavParams = (obj)=>{
    setNavParams({
        ...navParams,
        ...obj
    })
  }
  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <MasterFollowUps handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default MasterFollowUpsContainer